import React, { FC } from 'react';

import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { AbstractIcon } from '../abstract-icon';

interface Props {
  className?: string;
}

const ChevronRightIcon: FC<Props> = props => <AbstractIcon {...props} icon={faChevronRight} />;

export { ChevronRightIcon };